import modules from './modules/modules';
import pages from './pages/scripts/pages';

const functionsInit = () => {
    modules();
    pages();
};

export default functionsInit;